module.exports = __webpack_public_path__ + "img/c2.935a102d.png";